const alert = require('vue-strap').alert;

export default  {
  name: 'thumbnail',
  components: { alert },
  props: [
    'picture',
    'picture_url',
  ],
  mounted() {},
  data() {
    return {
      pictureLocal: null,
      pictureUrlLocal: null,
      alertError: {
        text: 'Some required fields are not filled',
        title: 'Error!',
        visible: false,
      },
    };
  },
  methods: {
    readURL(input, rotateElem) {
      const self = this;
      // const elem = input.parentElement.parentElement.parentElement;
      if (input.files && input.files[0]) {
        this.pictureLocal = input.files[0];
        const reader = new FileReader();
        reader.onload = function (e) {
          // $('#icon').attr('src', e.target.result);
          self.pictureUrlLocal = e.target.result;
          self.imageOrientation(input, self, rotateElem);
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    handleFileChange(e, rotateElem) {
      // this.formData.img = e.target.files[0].name;
      this.$emit('change');
      e.preventDefault();
      if (e.target.files && e.target.files[0] && e.target.files[0].size > 5000000) {
        e.target.value = '';
        this.alertError.text = 'Maximum allowed file size is 5 MB.';
        this.alertError.visible = true;
        return;
      }
      this.readURL(e.target, rotateElem);
    },
    getOrientation(file, callback) {
      var reader = new FileReader();
      reader.onload = function(e) {
        var view = new DataView(e.target.result);
        if (view.getUint16(0, false) != 0xFFD8) return callback(-2);
        var length = view.byteLength, offset = 2;
        while (offset < length) {
          var marker = view.getUint16(offset, false);
          offset += 2;
          if (marker == 0xFFE1) {
            if (view.getUint32(offset += 2, false) != 0x45786966) return callback(-1);
            var little = view.getUint16(offset += 6, false) == 0x4949;
            offset += view.getUint32(offset + 4, little);
            var tags = view.getUint16(offset, little);
            offset += 2;
            for (var i = 0; i < tags; i++)
              if (view.getUint16(offset + (i * 12), little) == 0x0112)
                return callback(view.getUint16(offset + (i * 12) + 8, little));
          }
          else if ((marker & 0xFF00) != 0xFF00) break;
          else offset += view.getUint16(offset, false);
        }
        return callback(-1);
      };
      reader.readAsArrayBuffer(file);
    },
    imageOrientation(input, self, img) {
      self.getOrientation(input.files[0], function(orientation) {
        // let img = document.getElementById('icon-frame');
        img.className = ' ';
        if (orientation === 6 || orientation === 5) {
          img.className += 'rotate90';
        }
        if (orientation === 8 || orientation === 7) {
          img.className += 'rotate270';
        }
        if (orientation === 3 || orientation === 4) {
          img.className += 'rotate180';
        }
      });
    },
    deletePicture(e) {
      this.$emit('change');
      this.$refs.fileinput.reset();
      setTimeout(() => {
        this.pictureUrlLocal = '';
        this.pictureLocal = '';
        this.$emit('update:picture', '');
      }, 1);
    },
  },
  watch: {
    pictureLocal() {
      this.$emit('update:picture', this.pictureLocal);
    },
    pictureUrlLocal() {
      this.$emit('update:picture_url', this.pictureUrlLocal);
    },
    picture_url() {
      this.pictureUrlLocal = this.picture_url;
    },
  },
  created() {
    this.pictureLocal = this.picture;
    this.pictureUrlLocal = this.picture_url;
  },
  computed: {

  },
};



// WEBPACK FOOTER //
// ./src/components/thumbnail/thumbnail.component.js